import { render, staticRenderFns } from "./CalculateOrderPrice.vue?vue&type=template&id=7d8f3f86&"
import script from "./CalculateOrderPrice.vue?vue&type=script&lang=js&"
export * from "./CalculateOrderPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports